export function getToken (cid) {
  const tokenKey = `${cid}-token`
  let val = localStorage.getItem(tokenKey)
  if (!val) {
    return val
  }
  val = JSON.parse(val)
  // if (new Date().getTime() > val.expire) {
  //   localStorage.removeItem(tokenKey)
  //   console.log('沒token')
  //   return null
  // }
  // console.log(val.token)
  return val.token
}

export function setToken (token, cid) {
  const tokenKey = `${cid}-token`
  const tokenObj = {
    token: token,
    expire: new Date().getTime() + 50 * 60 * 1000
  }

  return localStorage.setItem(tokenKey, JSON.stringify(tokenObj))
}

export function removeToken (cid) {
  const tokenKey = `${cid}-token`
  return localStorage.removeItem(tokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js